import { z } from "zod";
export const PaginationHeaders = z.object({
    prevPage: z.coerce.number().optional(),
    currentPage: z.coerce.number(),
    nextPage: z.coerce.number().optional(),
    pageSize: z.coerce.number(),
    totalPages: z.coerce.number(),
    totalCount: z.coerce.number(),
});
export const parsePaginationHeaders = (headers) => {
    const paginationHeaders = {
        prevPage: headers["ff-prev-page"],
        currentPage: headers["ff-page"],
        nextPage: headers["ff-next-page"],
        pageSize: headers["ff-page-size"],
        totalPages: headers["ff-total-pages"],
        totalCount: headers["ff-total"],
    };
    const parsedHeaders = PaginationHeaders.safeParse(paginationHeaders);
    return parsedHeaders.success ? parsedHeaders.data : undefined;
};
//# sourceMappingURL=parsePaginationHeaders.js.map